// extracted by mini-css-extract-plugin
module.exports = {"item":"M_dh","item__image":"M_dj","item__title":"M_dk","item__counter":"M_dl","item__active":"M_dm"};